import React from 'react';
import { Card } from 'react-bootstrap';

import { getOrderMinValue, maskMoney } from '@/services/global';
import { ICartCombo } from '@/store/ducks/combos/types';

import CartProductsList from './CartProductsList';

interface CartContentProps {
  shipmentCardStyle: React.CSSProperties;
  showCartDeliveryAlert: boolean;
  order: any;
  min_order_amount: number;
  combos: ICartCombo[];
  setEditProducts: (products: any) => void;
  setProductToCombo: (productToCombo: any) => void;
  hideQuantityInput?: boolean;
}

export default function CartContent({
  shipmentCardStyle,
  showCartDeliveryAlert,
  order,
  min_order_amount,
  combos,
  setEditProducts,
  setProductToCombo,
  hideQuantityInput = false,
}: CartContentProps) {
  return (
    <Card className="shipment-card mb-3 mb-sm-2">
      <Card.Header style={shipmentCardStyle}>Meu carrinho</Card.Header>
      <Card.Body>
        {showCartDeliveryAlert && (
          <div className="d-flex align-items-center justify-content-center bg-light">
            <span className="py-2">
              O valor mínimo do total pedido é de
              <strong className="ml-1">
                {maskMoney(getOrderMinValue(order, min_order_amount), true)}
              </strong>
            </span>
          </div>
        )}

        <CartProductsList
          order={order}
          combos={combos}
          setEditProducts={setEditProducts}
          setProductToCombo={setProductToCombo}
          hideQuantityInput={hideQuantityInput}
        />
      </Card.Body>
    </Card>
  );
}
